var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.177,
    height: 20.001,
    viewBox: "0 0 21.177 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "news",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M90.884,0H75.59A.588.588,0,0,0,75,.588V18.236A2.912,2.912,0,0,1,74.4,20H88.532a2.944,2.944,0,0,0,2.941-2.941V.588A.588.588,0,0,0,90.884,0Zm-3.53,15.295H79.119a.588.588,0,1,1,0-1.176h8.236a.588.588,0,1,1,0,1.176Zm0-3.53H79.119a.588.588,0,1,1,0-1.176h8.236a.588.588,0,1,1,0,1.176Zm0-3.53H79.119a.588.588,0,1,1,0-1.176h8.236a.588.588,0,1,1,0,1.176Zm0-3.53H79.119a.588.588,0,1,1,0-1.176h8.236a.588.588,0,1,1,0,1.176Zm0,0",
    transform: "translate(-70.295)",
    fill: "#593a7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M2.941,42.668H.588A.588.588,0,0,0,0,43.256V58.551a1.765,1.765,0,1,0,3.53,0V43.256a.588.588,0,0,0-.588-.588Zm0,0",
    transform: "translate(0 -40.315)",
    fill: "#593a7c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNews);
export default __webpack_public_path__ + "static/media/sidebarNews.181ceb3c.svg";
export { ForwardRef as ReactComponent };